import { Component, ElementRef, ViewChild, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import {
  CategoryNewsService,
  NewsCategoryLabel,
} from '../../services/category-news.service';
import { Router } from '@angular/router';
import { Timestamp } from '@angular/fire/firestore';

@Component({
  selector: 'app-category-news',
  templateUrl: './category-news.component.html',
  styleUrls: ['./category-news.component.scss'],
})
export class CategoryNewsComponent {
  public NewsCategoryLabel = NewsCategoryLabel;

  @Input() category: string | null = null;   // <<<<<< novoF

  @ViewChild('cards') cardsRef: ElementRef<HTMLElement | null> = new ElementRef(null);

  constructor(
    private router: Router,
    public categoryNewsService: CategoryNewsService
  ) {
    // this.categoryNewsService.filterValue = this.router.url.substring(1);
    // this.categoryNewsService.getPosts();
  }

  ngOnInit() { this.applyFilter(); }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['category']) this.applyFilter();
  }

  private applyFilter() {
    // se veio por input, usa; senão, trate a URL: se não for 'blog' / 'categoria/*', mostre últimas (vazio)
    const slugFromUrl = this.router.url.substring(1); // ex: '', 'blog', 'categoria/xyz', 'embaixadores'
    const slug = (this.category !== null && this.category !== undefined)
      ? this.category
      : (slugFromUrl.startsWith('blog') || slugFromUrl.startsWith('categoria') ? slugFromUrl : '');

    this.categoryNewsService.filterValue = slug; // '' => últimas
    this.categoryNewsService.getPosts();
  }

  timestampToDate(ts: Timestamp) {
    return new Timestamp(ts.seconds, ts.nanoseconds).toDate();
  }

  btoa(str: any) { return btoa(String(str)); }

  // timestampToDate(ts: Timestamp) {
  //   return new Timestamp(ts.seconds, ts.nanoseconds).toDate();
  // }

  // btoa(string: any) {
  //   return btoa(String(string));
  // }
}
